import axios from 'axios'
import qs from 'qs'

const url = location.href
const domain = url.split('.')[0]
export function request({ method, url, data={}, resType }) {
  if(url != '/api/user/getStepInfo'){
    data.platform = 'web'
    data.from = 'h5'
    data.channel = 'website'
    data.userAgent = navigator.userAgent
  }
  return axios({
    method: method,
    baseURL: "https://dc.fcredit.kz",
    url: url,
    data: data,
    params: data,
    responseType: resType === 'blob' ? 'blob' : 'json',
    headers: {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('token') || ''
      }
  })
}



// WEBPACK FOOTER //
// ./src/utils/request.js